export default function reengagement() {
  createWave();
  if ($(".waveform").length > 0) {
    $(".entry-header").hide();
    $(".block").hide();
  }

  const fields = $(".waveform .gfield");
  for (let i = 2; i < fields.length; i++) {
    fields.eq(i).hide();
    $(".block-featured-content-panel-2").hide();
  }

  const Q1choices = fields.eq(1).find(".gchoice");
  Q1choices.each(function(choiceIndex) {
    $(this).on("click", function() {
      //text field - choice field
      transition(
        fields.eq(choiceIndex * 2 + 2),
        fields.eq(choiceIndex * 2 + 3)
      );
    });
  });

  //display result text when choice is picked

  $(".question2").each(function(firstAnswer) {
    $(this)
      .find(".gchoice")
      .each(function(secondAnswer) {
        $(this).on("click", function() {
          transition(
            $(`.choice${firstAnswer + 1}`).eq(secondAnswer),
            $(`.response-${firstAnswer + 1}-${secondAnswer + 1}`)
          );

          $(
            `.block-featured-content-panel-2.response-${firstAnswer +
              1}-${secondAnswer + 1}`
          )
            .find(".featured-content-panel-two__column")
            .eq(1)
            .addClass("sustain-bottle-wave");

          $(".block:not([class*='response'])").show();
        });
      });
  });
}

function transition(id_1, id_2) {
  $(".waves").show();
  setTimeout(function() {
    $(".gfield").hide();
    $(id_1).show();
    $(id_2).show();
  }, 1000);

  setTimeout(function() {
    $(".waves").hide();
  }, 1250);
}

function createWave() {
  const lowerWave =
    '<svg width="102vw" height="auto" viewBox="0 0 1517 162" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1500 87.2501V161.179H0C0 112.611 0 64.0322 0 15.4644C15.7393 24.1858 30.9964 33.9787 47.3143 41.4251C107.796 69.0358 171.321 72.2822 236.175 63.2822C284.732 56.543 331.8 43.0108 379.511 32.3715C417.129 23.9715 454.757 15.3251 492.739 8.92867C556.414 -1.78562 620.379 -1.56062 684.171 9.03581C739.607 18.2394 793.618 33.1108 846.996 50.3715C905.925 69.4215 964.564 89.3394 1023.58 108.1C1081.49 126.518 1140.3 141.272 1200.89 148.043C1257.31 154.354 1313.14 151.675 1368.34 137.779C1414.29 126.218 1458.01 109.022 1500.01 87.2501H1500Z" fill="#0072CE"/></svg>';

  const upperWave =
    '<svg width="102vw" height="auto" viewBox="0 0 1517 177" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_216_1341)"><path d="M1508 98.2599V172.188H8C8 123.621 8 75.042 8 26.4741C23.7393 35.1956 38.9964 44.9884 55.3143 52.4349C115.796 80.0456 179.321 83.292 244.175 74.292C292.732 67.5527 339.8 54.0206 387.511 43.3813C425.129 34.9813 462.757 26.3349 500.739 19.9384C564.414 9.22415 628.379 9.44915 692.171 20.0456C747.607 29.2491 801.618 44.1206 854.996 61.3813C913.925 80.4313 972.564 100.349 1031.58 119.11C1089.49 137.528 1148.3 152.281 1208.89 159.053C1265.31 165.363 1321.14 162.685 1376.34 148.788C1422.29 137.228 1466.01 120.031 1508.01 98.2599H1508Z" fill="#338ED8"/></g><defs><filter id="filter0_d_216_1341" x="0" y="0" width="1516.01" height="176.188" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="-4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.356863 0 0 0 0 0.647059 0 0 0 0.5 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_216_1341"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_216_1341" result="shape"/></filter></defs></svg>';

  $("main").append(
    '<div class="waves"><div class="wave-container">' +
      '<div class="wave front"><div class="wave-head">' +
      upperWave +
      '</div><div class="wave-body front"></div></div>' +
      '<div class="wave back"><div class="wave-head">' +
      lowerWave +
      '</div><div class="wave-body back"></div></div>' +
      "</div></div>"
  );
  $(".waves").hide();
}
